import Landing from "../../components/landing/LandingPage";
import { Toaster } from "../../components/ui/sonner";

// Create a public layout that doesn't include OrgRedirect or
// initialize Pyodide services unnecessarily
const PublicLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            <Toaster position="top-right" closeButton />
            {children}
        </>
    );
};

export default function LandingPage() {
    return (
        <PublicLayout>
            <Landing />
        </PublicLayout>
    );
}